import * as React from "react";
import { List } from "antd";
import { AccountSelectorTradingAccountListItem } from "./AccountSelectorTradingAccountListItem";
import { WrappedComponentProps, injectIntl } from "react-intl";
import { TradingAccount } from "swan-public-api-client";

interface Props extends WrappedComponentProps {
  tradingAccounts: TradingAccount[];
  onTradingAccountSelected: (tradingAccount: TradingAccount) => void;

  bordered?: boolean;
}

class AccountSelectorTradingAccountListCmp extends React.PureComponent<Props> {
  public render() {
    return (
      <List
        className="trading-account"
        dataSource={this.props.tradingAccounts}
        renderItem={item => (
          <AccountSelectorTradingAccountListItem tradingAccount={item} onTradingAccountSelected={tradingAccount => this.props.onTradingAccountSelected(tradingAccount)} />
        )}
        bordered={this.props.bordered}
      />
    )
  }
}

export const AccountSelectorTradingAccountList = injectIntl(AccountSelectorTradingAccountListCmp);